/* global axios */
import ApiClient from './ApiClient';

class OnboardingProgressAPI extends ApiClient {
  constructor() {
    super('onboarding_progress', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  markStep(stepId) {
    return axios.patch(
      `${this.baseUrl()}/onboarding_step_completions/${stepId}`
    );
  }

  unmarkStep(stepId) {
    return axios.delete(
      `${this.baseUrl()}/onboarding_step_completions/${stepId}`
    );
  }
}

export default new OnboardingProgressAPI();
